import TotalCard from "./TotalCard";

export default TotalCard;
